import { render, staticRenderFns } from "./funes_pres_import_F.vue?vue&type=template&id=11060264"
import script from "./funes_pres_import_F.vue?vue&type=script&lang=js"
export * from "./funes_pres_import_F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports